import { motion } from "framer-motion";
import { Building2, ShieldCheck, GraduationCap, Sparkles, Plane } from "lucide-react";
import { useLang } from "../../site-context";

const EASE = [0.22, 1, 0.36, 1];
const ICONS = {
  empresas: Building2,
  seguradoras: ShieldCheck,
  escolar: GraduationCap,
  ocasional: Sparkles,
  aeroporto: Plane,
};

export default function Services() {
  const { t } = useLang();
  return (
    <section id="servicos" className="relative py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="mb-14 max-w-2xl"
        >
          <p className="ff-mono mb-4 text-[11px] uppercase tracking-[0.35em] text-[#e3a008] sm:text-xs">
            {t.services_eyebrow}
          </p>
          <h2 className="ff-display text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {t.services_title}
          </h2>
          <p className="mt-4 text-base font-light leading-relaxed text-slate-400 sm:text-lg">
            {t.services_sub}
          </p>
        </motion.div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-6">
          {t.services.map((s, i) => {
            const Icon = ICONS[s.id];
            const wide = i >= 3;
            return (
              <motion.div
                key={s.id}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: (i % 3) * 0.12, ease: EASE }}
                whileHover={{ y: -8 }}
                className={`group relative overflow-hidden rounded-2xl border border-[#e3a008]/15 bg-[#12233f]/60 p-7 backdrop-blur-sm transition-colors duration-500 hover:border-[#e3a008]/45 ${
                  wide ? "lg:col-span-3" : "lg:col-span-2"
                }`}
              >
                <div
                  className="pointer-events-none absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#e3a008]/0 blur-3xl transition-all duration-700 group-hover:bg-[#e3a008]/15"
                  aria-hidden="true"
                />
                <div className="mb-5 inline-flex rounded-xl border border-[#e3a008]/25 bg-[#e3a008]/10 p-3">
                  <Icon className="h-6 w-6 text-[#e3a008]" strokeWidth={1.75} />
                </div>
                <h3 className="ff-display text-xl font-semibold text-white sm:text-2xl">{s.title}</h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-slate-400 sm:text-base">{s.desc}</p>
                <div className="mt-6 h-px w-full bg-gradient-to-r from-[#e3a008]/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
